//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Popover, Tooltip } from '@backmarket/design-system'

import translations from './Carrier.translations'

export default {
  components: {
    Popover,
    Tooltip,
  },
  props: {
    carriers: {
      type: Array,
      required: true,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    topLabel() {
      return this.$slots.icon
        ? this.$t(translations.carrierLabelSingular)
        : this.$t(translations.carrierLabelPlural)
    },
    carriersString() {
      return this.carriers.map((carrier) => carrier.name).join(', ')
    },
    lockedLabel() {
      return this.$t(translations.carrierTooltipLockedNew, {
        carrier: this.carriersString,
      })
    },
    unlockedLabel() {
      return this.$t(translations.carrierTooltipUnlockedNew, {
        count: this.carriers.length,
        carrier: this.carriersString,
      })
    },
    toolTipText() {
      return this.$slots.icon ? this.lockedLabel : this.unlockedLabel
    },
  },
}
